// German
export const de = {
  'app.name':           'Kardolive',
  'app.tagline':        'Kundenportal',
  'app.signOut':        'Abmelden',

  'login.email':        'E-Mail',
  'login.password':     'Passwort',
  'login.signIn':       'Anmelden',
  'login.signingIn':    'Anmeldung läuft…',
  'login.failed':       'Anmeldung fehlgeschlagen',
  'login.newAccount':   'Neu bei Kardolive?',
  'login.createAccount':'Kostenloses Konto erstellen →',

  'nav.workspace':      'Arbeitsbereich',
  'nav.templates':      'Vorlagen',
  'nav.live':           'Live',
  'nav.rooms':          'Räume & Chat',
  'nav.content':        'Inhalte',
  'nav.developer':      'Entwickler',
  'nav.account':        'Konto',

  'nav.overview':       'Übersicht',
  'nav.projects':       'Projekte',
  'nav.chat':           'Chat-Konsole',
  'nav.sessions':       'Sitzungen',
  'nav.streams':        'Live-Streams',
  'nav.studio':         'Studio',
  'nav.recordings':     'Aufzeichnungen',
  'nav.apiKeys':        'API-Schlüssel',
  'nav.webhooks':       'Webhooks',
  'nav.webhookTester':  'Webhook-Tester',
  'nav.networkTest':    'Netzwerktest',
  'nav.embed':          'Eingebettete Widgets',
  'nav.sdk':            'SDKs und Dokumentation',
  'nav.docs':           'Entwickler-Docs',
  'nav.analytics':      'Analyse',
  'nav.settings':       'Einstellungen',

  'overview.welcome':       'Willkommen zurück, {name}',
  'overview.plan':          '{tenant} · {plan}-Plan',
  'overview.newStream':     'Neuer Stream',
  'overview.kpi.live':           'Gerade live',
  'overview.kpi.live.broadcasting': 'Streams werden gesendet',
  'overview.kpi.live.nothing':    'nichts live',
  'overview.kpi.total':           'Streams gesamt',
  'overview.kpi.total.sub':       'aller Zeiten',
  'overview.kpi.sessions':        'Sitzungen · 30 Tage',
  'overview.kpi.sessions.sub':    'Veröffentlichungsereignisse',
  'overview.kpi.recordings':      'Aufzeichnungen',
  'overview.kpi.recordings.sub':  'spielbereit',
  'overview.recentStreams':       'Letzte Streams',
  'overview.recentSessions':      'Letzte Sitzungen',
  'overview.viewAll':             'Alle anzeigen →',
  'overview.empty.title':         'Noch keine Streams',
  'overview.empty.body':          'Erstellen Sie Ihren ersten Stream, um mit dem Senden zu beginnen.',
  'overview.empty.action':        'Stream erstellen',
  'overview.noSessions':          'Noch keine Sitzungen',

  'status.live':        'LIVE',
  'status.idle':        'INAKTIV',
  'status.ended':       'BEENDET',
  'status.archived':    'ARCHIVIERT',

  'common.save':        'Speichern',
  'common.cancel':      'Abbrechen',
  'common.delete':      'Löschen',
  'common.edit':        'Bearbeiten',
  'common.create':      'Erstellen',
  'common.confirm':     'Bestätigen',
  'common.loading':     'Wird geladen…',
  'common.error':       'Fehler',
  'common.retry':       'Wiederholen',

  // Dashboard navigation and account controls.
  "nav.skipContent": "Zum Seiteninhalt springen",
  "nav.streamTemplates": "Stream-Vorlagen",
  "nav.boards": "Interaktive Tafeln",
  "nav.menu": "Navigation öffnen",
  "nav.closeMenu": "Navigation schließen",
  "nav.scenarios": "Szenarien",
  "nav.premieres": "Premieren",
  "nav.clips": "Clips",
  "dashboard.account": "Konto",
  "dashboard.language": "Sprache",
  "dashboard.appearance": "Darstellung",
  "nav.allStreams": "Alle Streams",
  "nav.destinations": "Ziele",
  "nav.ecommerce": "E-Commerce",
  "nav.products": "Produkte",
  "nav.services": "Dienstleistungen",
  "nav.collections": "Kollektionen",
  "nav.orders": "Bestellungen",
  "nav.commerceSettings": "Handelseinstellungen",
  "nav.engagement": "Interaktion",
  "theme.light": "Zum hellen Modus wechseln",
  "theme.dark": "Zum dunklen Modus wechseln",
  "role.owner": "Inhaber",
  "role.admin": "Administrator",
  "role.member": "Mitglied",
  "role.viewer": "Betrachter",

  // Live Stream page content: never translate stored event names or API values.
  "streams.active": "Aktiv",
  "streams.archived": "Archiviert",
  "streams.monitor": "Signalmonitor",
  "streams.create": "Livestream erstellen",
  "streams.list": "Liste",
  "streams.grid": "Raster",
  "streams.view": "Streamansicht",
  "streams.searchLabel": "Veranstaltungen suchen",
  "streams.searchHint": "Nach Namen suchen",
  "streams.solutionFilter": "Nach Veranstaltungstyp filtern",
  "streams.statusFilter": "Nach Status filtern",
  "streams.dateFilter": "Nach Erstellungsdatum filtern",
  "streams.allSolutions": "Alle Typen",
  "streams.custom": "Bestehende oder eigene Einrichtung",
  "streams.allStatuses": "Alle Status",
  "streams.anyTime": "Beliebiges Erstellungsdatum",
  "streams.last7": "In den letzten 7 Tagen erstellt",
  "streams.last30": "In den letzten 30 Tagen erstellt",
  "streams.count": "{shown} von {total} Veranstaltungen angezeigt",
  "streams.noMatch": "Keine Veranstaltung entspricht den Filtern.",
  "streams.clearFilters": "Filter zurücksetzen",
  "streams.refreshFailed": "Streamliste konnte nicht aktualisiert werden",
  "streams.loadFailed": "Streams konnten nicht geladen werden",
  "streams.stale": "Die zuletzt geladene Liste wird angezeigt. Der Status kann sich geändert haben.",
  "streams.connectionHint": "Prüfen Sie die Verbindung und laden Sie die Liste erneut.",
  "streams.retrying": "Erneuter Versuch…",
  "streams.retry": "Erneut versuchen",
  "streams.restoreFailed": "Stream konnte nicht wiederhergestellt werden",
  "streams.restoreHint": "Prüfen Sie die Verbindung und aktualisieren Sie die Liste, um vor einem neuen Versuch den Status zu prüfen.",
  "streams.unused": "Unbenutzte Streams: {count}",
  "streams.unusedHint": "Keine Übertragungen oder Aufzeichnungen. Archivieren Sie diese Streams, um die Liste aufzuräumen. Es wird nichts gelöscht.",
  "streams.reviewArchive": "Prüfen und archivieren",
  "streams.loading": "Streams werden geladen…",
  "streams.archiveEmpty": "Keine archivierten Streams. Archivierte Streams und ihre Aufzeichnungen bleiben hier, bis Sie sie wiederherstellen.",
  "streams.restore": "Wiederherstellen",
  "streams.firstTitle": "Erstellen Sie Ihren ersten Stream",
  "streams.firstBody": "Wählen Sie eine Einrichtung für Verkauf, Unterricht oder Dienstleistungen, oder beginnen Sie mit einem leeren Stream. Senden Sie über Browser, Smartphone oder OBS.",
  "streams.blank": "Leerer Stream",
  "streams.broadcasts": "Übertragungen: {count}",
  "streams.replays": "Wiedergaben: {count}",
  "streams.sessions": "Sitzungen: {count}",
  "streams.recordings": "Aufzeichnungen: {count}",
  "streams.mode.BROADCAST": "Broadcast",
  "streams.mode.LOW_LATENCY": "Niedrige Latenz",
  "streams.mode.REALTIME": "Echtzeit",
  "streams.key": "Schlüssel",
  "streams.archiveTitle": "Unbenutzte Streams archivieren",
  "streams.archiveHint": "Diese Streams wurden noch nie gesendet. Sie können sie jederzeit unter Archiviert wiederherstellen.",
  "streams.archiveFailed": "{count} Streams konnten nicht archiviert werden; sie senden möglicherweise bereits live. Die übrigen wurden archiviert.",
  "streams.archiving": "Wird archiviert…",
  "streams.archiveCount": "{count} archivieren",
  "streamType.webinar": "Business-Webinare und Produkteinführungen",
  "streamType.classroom": "Unterricht und Nachhilfe",
  "streamType.training": "Unternehmensschulungen",
  "streamType.conference": "Konferenzen und Ausstellungen",
  "streamType.shopping": "Live-Shopping",
  "streamType.auction": "Live-Auktionen",
  "streamType.consultation": "Private Beratungen",
  "streamType.creator": "Creator- und Community-Streams",
  "streamType.audio": "Audioräume und Podcasts",
  "streamType.sports": "Sport und E-Sport",
  "streamType.performance": "Konzerte und Aufführungen",
  "streamType.community": "Gottesdienste und Spendenaktionen",
  "streamType.tour": "Führungen und Vorführungen",
  "streamType.fitness": "Fitness und Workshops",
  "streamType.public-meeting": "Nachrichten und öffentliche Sitzungen",
  "streamType.continuous": "Dauerkanäle und Kameras",
  "streams.close": "Schließen",
};
